/**
 * Email-format predicate shared by every email entry point (early-access
 * gate, support-mainnet form, rewards email capture). Deliberately loose —
 * the backend OTP + deliverability gate are the real validators; this only
 * blocks obviously-malformed input before a network call.
 */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
